import React from 'react';
import { Trans } from 'react-i18next';
import { ROUTE } from 'constants/route';
import ButtonAdd from 'components/ButtonAdd';
import { RIGHTS } from 'constants/rights';

const Actions = () => (
  <ButtonAdd
    size="small"
    to={ROUTE.USER_GROUP_DETAIL.replace(':recordId', 'new')}
    right={RIGHTS.USER_GROUP.ADD}
  >
    <Trans>USER_GROUP.NEW</Trans>
  </ButtonAdd>
);

export default Actions;
